import { ArrowPathIcon, CheckCircleIcon, CheckIcon, EyeIcon, MinusCircleIcon, XCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Button, Card, CardBody, Checkbox, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Textarea, Tooltip, useDisclosure } from "@nextui-org/react";
import ModalAlert from "../../../../elements/ModalAlert";
import useSWR from "swr";
import { getFetcher, putFetcher, getValidationPTSP } from "../../../../../services/api";
import toast from "react-hot-toast";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
//import StatusPermohonanRegistrasi from '../../../../../enums/statusRegistrasi';

export default function Validation({ registrasi }) {
  const [loadingRows, setLoadingRows] = useState({});
  const [editId, setEditId] = useState(null);

  // 1. Correct the useSWR hook to handle the API response format
  const { data, isLoading, mutate } = useSWR(`/api/validasi/dokumen/${registrasi.nomor}`, getFetcher);
  const { isOpen: isOpenModalForm, onOpen: onOpenModalForm, onOpenChange: onOpenChangeModalForm, onClose: onCloseModalForm } = useDisclosure();
  const { isOpen: isOpenModalAlert, onOpenChange: onOpenChangeModalAlert } = useDisclosure();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const columns = ["No", "Persyaratan", "Nomor Dokumen", "Dokumen", "Kesesuaian Dokumen", "Catatan"];

  function viewDok(url) {
    const urlPtsp = process.env.REACT_APP_URL_API_PTSP || "https://perizinan.kemenlh.go.id/api/";
    let finalUrl = url;

    // Regex untuk detect pattern http://[IP]/api/
    // Pattern: http:// diikuti angka.angka.angka.angka/api/
    const ipPattern = /^http:\/\/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\/api\//;

    if (url && ipPattern.test(url)) {
      // Replace dari awal URL sampai /api/ dengan URL PTSP
      finalUrl = url.replace(ipPattern, urlPtsp);
    }

    const link = document.createElement("a");
    link.href = finalUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <Card>
        <CardBody>
          <Table removeWrapper aria-label="validation-table" radius="sm">
            <TableHeader>
              {columns.map((item, index) => (
                <TableColumn key={index}>{item}</TableColumn>
              ))}
            </TableHeader>
            <TableBody loadingContent={<Spinner />} emptyContent={isLoading ? "Loading..." : "Tidak ada data"}>
              {/* Hanya render data jika ada dan berupa array */}
              {data?.data && Array.isArray(data.data) && data.data.length > 0
                ? data.data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.no}</TableCell>
                      <TableCell>{item.persyaratan}</TableCell>
                      <TableCell>{item.nomor_dokumen}</TableCell>
                      <TableCell>
                        <Button onClick={() => viewDok(item.dokumen)} isIconOnly size="sm" color="primary">
                          <EyeIcon className="size-4" />
                        </Button>
                      </TableCell>
                      <TableCell>{item.kesesuaian_dokumen}</TableCell>
                      <TableCell>{item.catatan}</TableCell>
                    </TableRow>
                  ))
                : []}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
}
